import { queryOptions } from "@tanstack/react-query";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const invoiceByAppointmentIdsQueryOptions = (params: {
  appointmentIds: string[];
  onBehalfOf?: string;
}) => {
  return queryOptions({
    queryKey: ["invoiceByAppointmentIds", params],
    queryFn: async ({ signal }) => {
      const url = `/api/invoicing/get_by_appointment_ids${
        params.onBehalfOf ? `?on_behalf_of=${params.onBehalfOf}` : ""
      }`;

      const res = await fetchOrchidAPI(url, {
        signal,
        method: "POST",
        body: JSON.stringify({
          appointment_ids: params.appointmentIds,
        }),
      });
      if (!res.ok) {
        throw new Error(
          `failed to query invoice data: ${getErrorDetail(await res.text())}`,
        );
      }
      const json = await res.json();
      return json as { invoices: InvoiceData[] };
    },
  });
};

export default invoiceByAppointmentIdsQueryOptions;
